<template>
  <woot-modal :show.sync="show" :on-close="onClose">
    <div class="column content-box">
      <woot-modal-header
        :header-title="$t('AGENT_MGMT.ADD.TITLE')"        
      />
      <form-agent-multi-account :is-submitting="uiFlags.isCreating" @submit="onSubmit" @cancel="onClose"/>
    </div>
  </woot-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import FormAgentMultiAccount from './FormAgentMultiAccount';

export default {
  components: {
    FormAgentMultiAccount,
  },
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {      
      show: true      
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'agents/getUIFlags'      
    }),    
  },  
  methods: {
    showAlert(message) {
      bus.$emit('newToastMessage', message);
    },
    async onSubmit(dataAgent) {
      try {        
        await this.$store.dispatch('agents/create', dataAgent);
        this.showAlert(this.$t('AGENT_MGMT.ADD.API.SUCCESS_MESSAGE'));
        this.onClose(true);
      } catch (error) {
        const { response: { data: { error: errorResponse = '' } = {} } = {} } =
          error;
        let errorMessage = '';
        if (error.response.status === 422) {
          errorMessage = this.$t('AGENT_MGMT.ADD.API.EXIST_MESSAGE');
        } else {
          errorMessage = this.$t('AGENT_MGMT.ADD.API.ERROR_MESSAGE');
        }
        this.showAlert(errorResponse || errorMessage);
      }
    },    
  },
};
</script>